<template>
    <li class="menu-link">
        <router-link :to="model.url" v-if="!isExternal"><span>{{ model.text }}</span></router-link>
        <a :href="model.url" v-if="isExternal" target="_blank"><span>{{ model.text }}</span></a>
    </li>
</template>

<script lang="js">
    export default {
        name: "nav-menu-item",
        props: {
            model: Object
        },
        data() {
            return {
                open: false
            }
        },
        computed: {
            isExternal() {
                return this.model.url.startsWith("http");
            }
        },
        methods: {
            toggleOpen() {
                this.open = !this.open;
            }
        },
        watch: {
            '$route'() {
                if (this.open) this.toggleOpen();
            }
        }
    };
</script>

<style>
    li.menu-link {
        margin: 2px 0 0 0;
        display: block;
        text-align: center;
    }
        ul:not(.sub-menu) > li.menu-link:first-child {
            margin-top: 0;
        }

    li.menu-link a {
        display: block;
        background-color: var(--blue1);
        color: var(--white1);
        padding: 0.8125rem 2.5rem 0.8125rem 1.5rem;
        text-decoration: none;
        text-transform: uppercase;
        font-size: var(--font-size-1);
        font-weight: 300;
        line-height: 1rem;
        width: 100%;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

        li.menu-link a span {
            display: inline-block;
        }

            li.menu-link a span:after {
                content: "";
                display: block;
                border-bottom: solid 1px transparent;
                margin-top: 0.25em;
                margin-right: auto;
                margin-left: auto;
                width: calc(80% - 0.85em);
                -moz-transition: all linear .2s;
                -o-transition: all linear .2s;
                -webkit-transition: all linear .2s;
                transition: all linear .2s;
            }

        li.menu-link a:hover span:after {
            width: 100%;
            border-bottom-color: var(--white1);
            -moz-transition: all linear .2s;
            -o-transition: all linear .2s;
            -webkit-transition: all linear .2s;
            transition: all linear .2s;
        }

    @media screen and (min-width: 800px) {
        ul.root-menu > li.menu-link {
            margin-top: 0;
        }

        li.menu-link {
            position: relative;
            margin-top: 1px;
            -ms-flex: 0 0 auto;
            -webkit-flex: 0 0 auto;
            flex: 0 0 auto;
        }

            li.menu-link a {
                background-color: transparent;
                color: var(--black1);
                text-align: center;
                white-space: nowrap;
            }

                li.menu-link a:hover span:after {
                    border-bottom-color: var(--black1);
                }

    }

</style>